<template>
  <!-- "Vai pazīstami?" — the visitor recognises their own evening. Second person, never a name or
       quote marks: these are situations, not testimonials (website-content-spec §3.2). -->
  <v-container fluid class="py-14 as-home-section as-home-section--white">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="9">
        <h2 class="as-home-heading">{{ $t('pages.home-view.pains.title') }}</h2>
        <p class="as-home-subheading">{{ $t('pages.home-view.pains.subtitle') }}</p>

        <v-row>
          <v-col v-for="pain in pains" :key="pain.key" cols="12" sm="6" class="d-flex">
            <div class="as-home-pain-card">
              <div class="as-home-pain-card__situation">
                <v-icon class="as-home-pain-card__icon" color="var(--color-pallet-2)">{{ pain.icon }}</v-icon>
                <span>{{ $t(`pages.home-view.pains.items.${pain.key}.situation`) }}</span>
              </div>
              <div class="as-home-pain-card__change">
                <v-icon small color="var(--color-pallet-1)" class="mr-2 flex-shrink-0">mdi-arrow-right-circle</v-icon>
                <span>{{ $t(`pages.home-view.pains.items.${pain.key}.change`) }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/**
 * Exactly these 4, in this order, every time (website-content-spec §13.3). Rules last: it is the best
 * paying customer's own reason (Jumping Jūrmala, 2026-10-20).
 */
const PAINS = [
  { key: 'whatsapp', icon: 'mdi-message-text-clock-outline' },
  { key: 'who-paid', icon: 'mdi-bank-outline' },
  { key: 'passes', icon: 'mdi-notebook-outline' },
  { key: 'rules', icon: 'mdi-gavel' }
]

export default {
  name: 'HomePainSection',
  data: () => ({
    pains: PAINS
  })
}
</script>

<style>
.as-home-pain-card {
  background: var(--color-white);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.as-home-pain-card__situation {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.45;
  color: var(--color-pallet-5);
  min-width: 0;
  overflow-wrap: anywhere;
}

.as-home-pain-card__icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.as-home-pain-card__change {
  display: flex;
  align-items: flex-start;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  color: var(--color-pallet-2);
  line-height: 1.55;
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
